import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "border-0 rounded-3 border position-relative z-1 mb-4 play-for-rtl",
  style: {"background":"linear-gradient(84deg, #23272e 3.5%, #526077 94.93%)"}
}
const _hoisted_2 = {
  class: "card-body px-4",
  style: {"padding-top":"37px","padding-bottom":"24px"}
}
const _hoisted_3 = {
  class: "bg-body-color-50 d-inline-block text-white fd-12 fw-medium rounded-pill mb-2",
  style: {"padding":"0 11px"}
}
const _hoisted_4 = { class: "fs-28 fw-medium text-body-bg mb-1" }
const _hoisted_5 = {
  class: "text-light",
  style: {"max-width":"370px","margin-bottom":"18px"}
}
const _hoisted_6 = { class: "d-flex flex-wrap gap-2 align-items-center" }
const _hoisted_7 = {
  class: "d-flex align-items-center rounded-pill",
  style: {"border":"1px solid #64748b","padding":"3.5px 12px"}
}
const _hoisted_8 = { class: "ms-2 text-body-bg" }
const _hoisted_9 = {
  class: "d-flex align-items-center rounded-pill",
  style: {"border":"1px solid #64748b","padding":"3.5px 12px"}
}
const _hoisted_10 = { class: "ms-2 text-body-bg" }
const _hoisted_11 = {
  class: "audio-player-for-wave",
  style: {"padding":"47px 0"}
}
const _hoisted_12 = { class: "d-sm-flex align-items-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "ms-sm-3 mt-3 mt-sm-0" }
const _hoisted_15 = {
  class: "d-flex align-items-center justify-content-between width-form-mobile",
  style: {"width":"325px"}
}
const _hoisted_16 = { class: "wave-container d-flex align-items-end" }
const _hoisted_17 = { class: "duration text-white" }
const _hoisted_18 = {
  class: "progress",
  role: "progressbar",
  "aria-label": "Audio Progress",
  style: {"height":"4px","background-color":"#8695aa"}
}
const _hoisted_19 = ["src", "onTimeupdate", "onEnded"]
const _hoisted_20 = { class: "d-flex flex-wrap gap-4 align-items-center" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "flex-grow-1 ms-10" }
const _hoisted_23 = { class: "d-block text-white fs-14 fw-medium lh-1" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "flex-grow-1 ms-10" }
const _hoisted_26 = { class: "d-block text-white fs-14 fw-medium lh-1" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "flex-grow-1 ms-10" }
const _hoisted_29 = { class: "d-block text-white fs-14 fw-medium lh-1" }
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "swiper-pagination-mastering-digital-marketing" }, null, -1)),
    _createVNode(_component_Swiper, {
      slidesPerView: 1,
      spaceBetween: 25,
      centeredSlides: false,
      preventClicks: true,
      loop: false,
      autoplay: {
        delay: 15000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper-pagination-mastering-digital-marketing',
        clickable: true,
      },
      modules: _ctx.modules,
      class: "mastering-digital-marketing-slide"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(slide.tag), 1),
                _createElementVNode("h3", _hoisted_4, _toDisplayString(slide.title), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(slide.description), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fs-14 fw-semibold text-body-bg" }, "Host:", -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(slide.host), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fs-14 fw-semibold text-body-bg" }, "Guest:", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(slide.guest), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "play-button border-0 rounded-circle d-inline-block",
                      style: {"background-color":"#c2cdff","width":"44px","height":"44px","line-height":"43px"},
                      onClick: ($event: any) => (_ctx.togglePlayPause(index))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["play-icon text-primary fs-28 position-relative", {
                    'ri-pause-fill': slide.isPlaying,
                    'ri-play-fill': !slide.isPlaying,
                  }]),
                        style: {"left":"2px"}
                      }, null, 2)
                    ], 8, _hoisted_13),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(70, (bar, barIndex) => {
                            return _createElementVNode("span", {
                              key: barIndex,
                              class: _normalizeClass(["wave-bar", { 'wave-animation': slide.isPlaying }])
                            }, null, 2)
                          }), 64))
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatTime(slide.currentTime)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: "progress-bar",
                          style: _normalizeStyle({ width: `${slide.progress}%`, height: '4px' })
                        }, null, 4)
                      ])
                    ])
                  ]),
                  _createElementVNode("audio", {
                    ref_for: true,
                    ref: `audioElement${index}`,
                    class: "audio-element",
                    src: slide.audioSrc,
                    onTimeupdate: ($event: any) => (_ctx.updateProgress(index)),
                    onEnded: ($event: any) => (_ctx.onAudioEnded(index))
                  }, null, 40, _hoisted_19)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", { class: "ri-customer-service-line fs-28 text-primary lh-1 position-relative top-2" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-light fs-12 fw-semibold lh-1" }, "Listens", -1)),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(slide.listens), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", { class: "ri-thumb-up-line fs-28 text-primary lh-1 position-relative top-2" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-light fs-12 fw-semibold lh-1" }, "Likes", -1)),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(slide.likes), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", { class: "ri-share-line fs-28 text-primary lh-1 position-relative top-2" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-light fs-12 fw-semibold lh-1" }, "Shares", -1)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(slide.shares), 1)
                    ])
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", { class: "ri-bookmark-line fs-28 text-primary lh-1 position-relative top-2" })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-10" }, [
                      _createElementVNode("span", { class: "text-light fs-12 fw-semibold lh-1" }, "Save for"),
                      _createElementVNode("span", { class: "d-block text-white fs-14 fw-medium lh-1" }, " Later ")
                    ])
                  ], -1))
                ])
              ]),
              _createElementVNode("img", {
                src: slide.imageSrc,
                class: "position-absolute bottom-0 end-0 z-n1 for-rtl-shape d-none d-md-block",
                alt: "shape"
              }, null, 8, _hoisted_30)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}